import OrderApi from "@/services/api/orderApi";

const OrderApiService = new OrderApi();

const dict = {
  custom: {
    "additional-information": {
      required: "Please fill out",
      max: "Cannot be greater than 500 chars",
    },
  },
};

export default {
  inject: ["$validator"],

  data() {
    return {
      reasons: [],
      decline_order_reason: null,
      additional_information: "",
    };
  },

  mounted() {
    this.$validator.localize("en", dict);
    this.getDeclineReasons();
  },

  methods: {
    pick,
    getDeclineReasons,
    validate,
    close,
  },
};

function pick(item) {
  this.decline_order_reason = item.value;
}

function getDeclineReasons() {
  OrderApiService.getDeclineReasons().then(({ data }) => {
    data.forEach((reason) => {
      this.reasons.push({ name: reason.label, value: reason.value });
    });
  });
}

function validate(scope) {
  this.$validator.validateAll(scope).then((valid) => {
    if (!valid) return;

    this.$emit("close-decline-order-modal", {
      decline_order_reason: this.decline_order_reason,
      additional_information: this.additional_information,
    });
  });
}

function close() {
  this.$emit("close-decline-order-modal");
}
